class Wishlist {
  constructor() {
    this.init();
    this.metafield_id = "";
  }

  init() {
    this.getUserById(customer_id);
  }

  async getUserById(id) {
    await fetch(
      window.SERVICE_URLS.api + "/customers/" +
        id +
        "/metafields?shop=" + encodeURIComponent(window.shop_domain || ""),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        data.metafields.forEach((element) => {
          if (element.key == "wishlist_json") {
            return (this.metafield_id = element.id);
          }
        });
      })
      .catch((error) => {});
  }

  async removeCreation(item) {
    window.WISHLIST = await this.fetchWishlist();

    console.log(window.WISHLIST);

    if (!window.WISHLIST) return;

    if (window.WISHLIST.products === undefined) {
      window.WISHLIST = {};
      window.WISHLIST.products = [];
    }

    window.WISHLIST.products = window.WISHLIST.products.filter(
      (element) =>
        element.properties["_ref_configuration"] !=
        item.properties["_ref_configuration"]
    );

    await fetch(
      window.SERVICE_URLS.api + "/customers/" +
        customer_id +
        "/wishlist?shop=" + encodeURIComponent(window.shop_domain || ""),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(window.WISHLIST),
      }
    )
      .then((response) => response.json())

      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async addCreation(item) {
    if (!customer_id || customer_id === "null" || customer_id === "undefined") {
      console.warn("[wishlist.addCreation] no customer_id — cannot persist to metafield");
      return false;
    }

    window.WISHLIST = await this.fetchWishlist();

    if (!window.WISHLIST) {
      console.error("[wishlist.addCreation] fetchWishlist returned null, aborting save");
      return false;
    }

    if (window.WISHLIST.products === undefined) {
      window.WISHLIST = {};
      window.WISHLIST.products = [];
    }

    let already_exists = false;

    window.WISHLIST.products.forEach((element) => {
      if (
        element.properties["_ref_configuration"] ==
        item.properties["_ref_configuration"]
      ) {
        already_exists = true;
      }
    });

    // set french date format
    item.updated_date = new Date().toLocaleDateString("fr-FR");

    if (!already_exists) {
      window.WISHLIST.products.unshift(item);
    } else {
      window.WISHLIST.products = window.WISHLIST.products.filter(
        (element) =>
          element.properties["_ref_configuration"] !=
          item.properties["_ref_configuration"]
      );

      window.WISHLIST.products.unshift(item);
    }

    try {
      const response = await fetch(
        window.SERVICE_URLS.api + "/customers/" +
          customer_id +
          "/wishlist?shop=" + encodeURIComponent(window.shop_domain || ""),
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(window.WISHLIST),
        }
      );
      const data = await response.json();
      if (!response.ok || data.errors || data.error) {
        console.error("[wishlist.addCreation] API error", response.status, data);
        return false;
      }
      return true;
    } catch (error) {
      console.error("[wishlist.addCreation] network error:", error);
      return false;
    }
  }

  async fetchWishlist() {
    return await fetch("/pages/mon-espace?view=wishlist-json&t=" + Date.now(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
        return null;
      });
  }
}

const wishlist = new Wishlist();

// Flush a pending wishlist save stored before a login redirect.
document.addEventListener("DOMContentLoaded", async function () {
  try {
    if (!customer_id || customer_id === "null" || customer_id === "undefined") return;
    const pending = sessionStorage.getItem("pendingWishlistSave");
    if (!pending) return;
    sessionStorage.removeItem("pendingWishlistSave");
    const item = JSON.parse(pending);
    const saved = await wishlist.addCreation(item);
    // After successful save, set a flag so the creations page shows a refresh notice
    if (saved) sessionStorage.setItem("creationJustSaved", "1");
  } catch (e) {
    console.error("[wishlist.flushPending] error", e);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".wishlist-basic-add").forEach((item) => {
    item.addEventListener("click", async function (e) {
      if (!customer_id) {
        window.location.href =
          "/customer_authentication/login?return_to=" +
          encodeURIComponent(window.location.pathname);
      } else {
        let state = e.currentTarget.classList.contains("actif")
          ? "remove"
          : "add";

        let hp = document
          .querySelector(".wishlist-basic-add")
          .classList.contains("actif");

        item.classList.toggle("actif");
        item.classList.add("animate");

        setTimeout(function () {
          document
            .querySelector(".wishlist-basic-add")
            .classList.remove("animate");
        }, 500);

        let wishlist = await fetch("/pages/mon-espace?view=wishlist-json-basic", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        wishlist = await wishlist.json();

        console.log(wishlist);

        // check if key products exists
        if (wishlist.products === undefined) {
          wishlist = {};
          wishlist.products = [];
        }

        // A product can be favourited once per profil (impression type), so a
        // favourite's identity is handle + ref_profil — not the handle alone.
        const currentRefProfil = item.dataset.refProfil || "";
        let has_product = false;

        wishlist.products.forEach((element) => {
          if (
            element.handle == item.dataset.handle &&
            (element.ref_profil || "") == currentRefProfil
          ) {
            has_product = true;
          }
        });

        if (has_product) {
          wishlist.products = wishlist.products.filter(
            (element) =>
              !(
                element.handle == item.dataset.handle &&
                (element.ref_profil || "") == currentRefProfil
              )
          );
        } else {
          // unshift so the most recently favourited product shows first
          wishlist.products.unshift({
            handle: item.dataset.handle,
            featured_image: item.dataset.featuredImage,
            title: item.dataset.title,
            category: item.dataset.category,
            ref_profil: currentRefProfil,
            updated_date: new Date().toLocaleDateString("fr-FR"),
          });
        }

        await fetch(
          window.SERVICE_URLS.api + "/customers/" +
            customer_id +
            "/wishlist_bis?shop=" + encodeURIComponent(window.shop_domain || ""),
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(wishlist),
          }
        )
          .then((response) => response.json())

          .then((data) => {
            return data;
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  });
});
